import { useContext, useEffect, useState } from "react";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import Card from "../../../../components/cards/Card";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import { Header, StyledDialog } from "../styles/GerenciamentoContrato";
import useGerenciamentoContratoController from "../controllers/GerenciamentoContratoController";
import { notify } from "../../../../utils/notify";
import SelectErp from "../../../../components/basics/SelectErp";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { useHistory } from "react-router";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

const ModalReativarContrato = ({
  open,
  setOpen,
  contractId,
  refreshFunction = () => {},
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();
  const { setLoading } = useContext(GerenciamentoContratoContext);

  const { handleReactivateContract, getCancelledInstallments } =
    useGerenciamentoContratoController();

  const [loadingList, setLoadingList] = useState(false);
  const [cancelledInstallments, setCancelledInstallments] = useState([]);
  const [reactivateFrom, setReactivateFrom] = useState(null);
  const [reasonForReactivation, setReasonForReactivation] = useState(null);

  useEffect(() => {
    if (!contractId) return;
    getCancelledInstallments(
      contractId,
      setLoadingList,
      setCancelledInstallments
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId]);

  const handleConfirmattion = async () => {
    if (reactivateFrom?.dueDate === null)
      return notify(
        "Verifique se a data de reativação das cobranças está preenchida.",
        true,
        "warning"
      );

    try {
      setLoading(true);
      const callback = await handleReactivateContract(
        contractId,
        reactivateFrom?.dueDate,
        reasonForReactivation
      );

      if (!callback.success)
        return notify(
          "Ocorreu um erro ao realizar o cancelamento do contrato."
        );

      handleClose();
      push("listagem?gfAccessToken=" + queryParams.gfAccessToken);
      return notify("Contrato reativado com sucesso!", true, "success");
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    refreshFunction();
    setOpen(false);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-cancelamento-contrato"
      >
        <StyledDialog>
          <DialogTitle id="dialog-title">
            <Header>
              <Grid container align="center" justifyContent="center">
                <Chip
                  bgcolor="tertiary"
                  textcolor="white"
                  label="REATIVAR CONTRATO"
                />
              </Grid>
            </Header>
          </DialogTitle>
          <DialogContent>
            <Card chipcolor="transparent">
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <SelectErp
                    label="REATIVAR COBRANÇAS A PARTIR DE:* "
                    value={reactivateFrom}
                    setValue={setReactivateFrom}
                    optionsList={cancelledInstallments}
                    descriptionField="value"
                    loading={loadingList}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextFieldErp
                    label="Motivo da Reativação"
                    value={reasonForReactivation}
                    setValue={setReasonForReactivation}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Card>
          </DialogContent>
          <DialogActions>
            <Btn onClick={handleClose} bgcolor="darkred" label="Cancelar" />
            <Btn
              onClick={handleConfirmattion}
              bgcolor="primary"
              label="Reativar"
            />
          </DialogActions>
        </StyledDialog>
      </Dialog>
    </>
  );
};

export { ModalReativarContrato };
